// extracted by mini-css-extract-plugin
export default {"ag-styles":"m_y","policyPage":"m_bs","introduction":"m_bt","policyList":"m_bv","settingsButton":"m_bw"};